import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../../models/book-widget-fields-master-config.interfaces';

export const flexAirportRulesOnChangeEval = (
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (updatedBookWidgetFields.flexAirportsField.checked) {
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      flexDatesField: {
        ...updatedBookWidgetFields.flexDatesField,
        disable: true,
        checked: false
      }
    };
  } else {
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      flexDatesField: {
        ...updatedBookWidgetFields.flexDatesField,
        disable: bookWidgetFieldsMasterConfig.flexDatesField?.disable || false
      }
    };
  }

  return updatedBookWidgetFields;
};
